import { IncomeCostTypeEnum } from 'api-hooks/transactions/income-cost';
import { themedStyled } from 'common/styles/styletron.theme';
import HOCInput from 'components/common/hoc-input';
import { Input } from 'components/elements';
import {
  CardSection,
  HalfContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function IncomCostDetail() {
  const { t } = useTranslation();
  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.number"
            label={t('common:number')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="select"
            name="approvalable.type"
            options={[
              {
                id: IncomeCostTypeEnum.income,
                label: t(`common:${IncomeCostTypeEnum.income}`),
              },
              {
                id: IncomeCostTypeEnum.cost,
                label: t(`common:${IncomeCostTypeEnum.cost}`),
              },
            ]}
            label={t('common:type')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.date"
            label={t('common:number')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="number"
            name="approvalable.total"
            label={t('common:amount')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.accountableType"
            label={t('common:account')}
          />
        </HalfContainer>
        <HalfContainer>
          <HOCInput keys={['approvalable.accountableType']}>
            {(_value) => {
              const value = _value['approvalable.accountableType'];
              return (
                <Input
                  type="text"
                  name="approvalable.account"
                  label={t(
                    `common:${
                      value === 'BankAccount' ? 'bank_account' : 'cash_account'
                    } `,
                  )}
                />
              );
            }}
          </HOCInput>
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.description"
            label={t('common:description')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="check-box"
            name="approvalable.isStatement"
            label={t('common:statement')}
          />
        </HalfContainer>
      </SectionContainer>
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
